export default __webpack_public_path__ + "static/lws-0e9db3903c70a307e86a59659a3b6b35.mp4";